

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Counter = () => {
  return (
    <Container>
      <section>
        <Row className="justify-content-center align-items-center">
          
          <Col className="text-center">
            <h1 style={{ color: 'white' }}>No. of Visitors</h1>
            <a href="https://www.hitwebcounter.com" target="_blank" rel="noopener noreferrer">
              <img
                src="https://hitwebcounter.com/counter/counter.php?page=13065590&style=0001&nbdigits=5&type=page&initCount=0"
                title="Counter Widget"
                alt="Visit counter For Websites"
                border="0"
              />
            </a>
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default Counter;
